/**
 * Component: SecurePlansComparation
 */

export default class SecurePlansComparation {
    constructor() {
        this.selectors = {
            root: '.js-secure-cards-compare',
            select: '.js-secure-plan-select',
            name: '.js-secure-plan-name',
            column: '.js-secure-plan',
            header: '.js-secure-cards-compare-names'
        };
        this.$rootElement = $(this.selectors.root);
        this.$select = this.$rootElement.find(this.selectors.select);
        this.$name = this.$rootElement.find(this.selectors.name);
        this.$column = this.$rootElement.find(this.selectors.column);
        this.$header = this.$rootElement.find(this.selectors.header);

        this.init();
    }

    init() {
        if (this.$select.length) {
            this.$select.on('change', (e) => {
                this.setSelectDisabled(e.target);
                const values = this.$select.map((index, el) => $(el).val());
                this.showColumn(values);
            });
        }
        this.resize();
    }

    setSelectDisabled(select) {
        this.$select.each((index, el) => {
            if ($(el).attr('data-compare-select') !== $(select).attr('data-compare-select')) {
                const value = $(select).val();
                const disabledItem = $(el).find('option[disabled]');
                const item = $(el).find(`option[value=${value}]`);
                $(disabledItem).removeAttr('disabled');
                $(item).attr('disabled', 'disabled');
            }
        });
    }

    showColumn(values) {
        let hasRecommended = false;

        this.$column.each((index, el) => {
            $(el).addClass('hide');
            $(values).each((i, val) => {
                if ($(el).attr('data-plan-info') === val || $(el).hasClass('title')) {
                    $(el).removeClass('hide');
                }
            });
            this.sortColumns(el, values, 'data-plan-info');
        });

        this.$name.each((index, el) => {
            $(el).addClass('hide');
            $(values).each((i, val) => {
                if ($(el).attr('data-plan-name') === val) {
                    $(el).removeClass('hide');
                    if ($(el).hasClass('recommended')) {
                        hasRecommended = true;
                    }
                }
            });

            this.sortColumns(el, values, 'data-plan-name');

            if (hasRecommended) {
                this.adjustTopSpace('36px');
            } else {
                this.adjustTopSpace('0px');
            }
        });
    }

    adjustTopSpace(space) {
        if ($(window).width() < 992) {
            $(this.$header).find('.secure-cards__compare-names').css('marginTop', space);
        } else {
            $(this.$header).find('.secure-cards__compare-names').css('marginTop', '0px');
        }
    }

    sortColumns(el, values, attr) {
        $(el).removeClass(['order-1', 'order-2', 'order-3']);
        $(values).each((i, val) => {
            if ($(el).attr(attr) === val) {
                $(el).addClass(`order-${i + 1}`);
            }
        });
    }

    resize() {
        let module = this;
        $(window).on('resize', function () {
            if ($(window).width() < 992 && module.$select.length) {
                const values = module.$select.map((index, el) => $(el).val());
                module.showColumn(values);
            } else {
                console.log(module.$rootElement);
                if (module.$rootElement.hasClass('secure-cards--reverse')) {
                    module.showColumn(['basic', 'plus', 'premium'].reverse());
                } else {
                    module.showColumn(['basic', 'plus', 'premium']);
                }
            }
        });
    }
}

